import { baseRequest } from '../common/request.js';
export const buildRecommendationsRequest = (req, path) => {
    return {
        ...baseRequest(req, path),
        requestParams: prepareRecommendationsRequestParams(req),
    };
};
const prepareRecommendationsRequestParams = (req) => {
    const { slotId, trackingId, clientId, context, language, country, currency, page, perPage, } = req;
    return {
        slotId,
        trackingId,
        clientId,
        context,
        language,
        country,
        currency,
        page,
        perPage,
    };
};
